import React from "react";
import classes from './ServicesAppellationsDocumet.module.scss'
import Document from "../../../../components/Document";
export default function ServicesAppellationsDocumet() {
    return(
        <Document/>

    )
    
}